import Add from '@mui/icons-material/Add'
import Delete from '@mui/icons-material/Delete'
import ExpandMore from '@mui/icons-material/ExpandMore'
import { Collapse, Grid, IconButton } from '@mui/material'
import { useState } from 'react'
import AddInterval from 'src/consumer/components/TimerComponent/CongratulatoryFlow/AddPractice/CreateNew/AddInterval/AddInterval'
import { MuiAddIntervalTimePopover } from 'src/consumer/components/TimerComponent/CongratulatoryFlow/AddPractice/CreateNew/styledComponents'
import { getDayJsDateFromMilliseconds } from 'src/shared/utils/dateTimeFormatting'

export default function AddTimerIntervalsComponent({
  intervals,
  setIntervals,
  intervalDurationLimits,
}) {
  const [addIntervalPopoverAnchor, setShowAddPopoverAnchor] = useState(null)
  const [collapseIntervals, setCollapseIntervals] = useState(false)

  function closeAddIntervalPopover() {
    setShowAddPopoverAnchor(null)
  }

  function addInterval(event) {
    setShowAddPopoverAnchor(event.currentTarget)
    setCollapseIntervals(false)
  }

  function deleteIntervalFromList(idx) {
    setIntervals((prev) => {
      const newIntervals = [...prev]
      newIntervals.splice(idx, 1)
      return newIntervals
    })
  }

  function addIntervalToIntervalList(interval) {
    setIntervals((prev) => [...(prev || []), interval])
    closeAddIntervalPopover()
  }

  function toggleCollapseIntervals() {
    setCollapseIntervals((prev) => !prev)
  }

  return (
    <>
      <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="center">
        <span>Interval Bells: {intervals?.length ? intervals?.length : 'None'}</span>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '6px',
          }}
        >
          {intervals?.length > 0 && (
            <IconButton onClick={toggleCollapseIntervals}>
              <ExpandMore
                sx={{
                  transition: '250ms all ease-in-out',
                  transform: collapseIntervals ? 'rotate(180deg)' : '',
                  color: 'white',
                }}
              />
            </IconButton>
          )}
          <IconButton onClick={addInterval} sx={{ color: 'white' }}>
            <Add />
          </IconButton>
        </div>
      </Grid>

      <Grid item xs={12}>
        <Collapse in={!collapseIntervals && intervals?.length > 0} unmountOnExit>
          <div style={{ background: '#535353', padding: '5px 10px', borderRadius: '7px' }}>
            <Grid container spacing={2}>
              {intervals?.map((interval, idx) => (
                <Grid
                  item
                  xs={12}
                  key={idx}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <span
                    style={{
                      color: intervalDurationLimits?.max < interval ? '#ff6666' : 'unset',
                    }}
                  >
                    {getDayJsDateFromMilliseconds(interval).format('mm:ss')}
                  </span>
                  {/* <Fade> */}
                  <IconButton onClick={() => deleteIntervalFromList(idx)} sx={{ color: '#ff6666' }}>
                    <Delete />
                  </IconButton>
                  {/* </Fade> */}
                </Grid>
              ))}
            </Grid>
          </div>
        </Collapse>
      </Grid>
      <MuiAddIntervalTimePopover
        open={Boolean(addIntervalPopoverAnchor)}
        anchorEl={addIntervalPopoverAnchor}
        onClose={closeAddIntervalPopover}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <AddInterval
          handleAddInterval={addIntervalToIntervalList}
          durationToToNotExceed={intervalDurationLimits?.max}
          allIntervals={intervals}
        />
      </MuiAddIntervalTimePopover>
    </>
  )
}
